'use strict';

var ansiRegex = require('ansi-regex');

var stripAnsi = function stripAnsi(string) {
  return typeof string === 'string' ? string.replace(ansiRegex(), '') : string;
};

module.exports = stripAnsi;
module.exports.default = stripAnsi;